<div class="white-box">
  <h3 [innerHTML]="'kids.verification_screen.title' | translate"></h3>
  <form [formGroup]="childForm" #childFormEl="ngForm" (ngSubmit)="saveChildInfo()">
    <div class="form-holder">
      <div class="form-row" [ngClass]="{ error: childFormEl.submitted && childForm.controls['owner_name'].invalid }">
        <label class="form-label" for="owner_name">{{ 'placeholder.name' | translate }} </label>
        <input
          class="form-input"
          formControlName="owner_name"
          type="text"
          name="owner_name"
          id="owner_name"
          [placeholder]="'placeholder.name' | translate"
          required
        />
      </div>
      <div class="form-row inline-form">
        <div class="form-row" [ngClass]="{ invalid: childFormEl.submitted && childForm.controls['gender'].invalid }">
          <label class="form-label">{{ 'account.personal-information.labels.gender.label' | translate }}</label>
          <div class="form-row inline-form radio">
            <div class="radio-item" (click)="childForm.get('gender').setValue('F')">
              <input class="form-radio" type="radio" formControlName="gender" value="F" id="F" />
              <label class="form-radio-label" for="F">
                {{ 'account.personal-information.labels.gender.female' | translate }}
              </label>
            </div>
            <div class="radio-item" (click)="childForm.get('gender').setValue('M')">
              <input class="form-radio" type="radio" formControlName="gender" value="M" id="M" />
              <label class="form-radio-label" for="M">
                {{ 'account.personal-information.labels.gender.male' | translate }}
              </label>
            </div>
          </div>
        </div>
        <div class="form-row" [ngClass]="{ invalid: childFormEl.submitted && childForm.controls['year_of_birth'].invalid }">
          <label for="year_of_birth" class="form-label">
            {{ 'kids.verification_screen.year' | translate }}
          </label>
          <input
            class="form-input"
            formControlName="year_of_birth"
            type="text"
            name="year_of_birth"
            id="year_of_birth"
            [placeholder]="'kids.verification_screen.year_placeholder' | translate"
            required
            (keypress)="allowNumericInputOnly($event)"
          />
        </div>
      </div>
    </div>
    <button type="submit" class="ui-button full-width">{{ 'personal.send' | translate }}</button>
  </form>
</div>
